export const data = [
    {
        id:1,
        image:'https://www.alltrails.com/api/alltrails/v2/trails/10303966/photos/0?size=larger_wide&key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i',
        title: "Southern Peak of Aragats",
        length:"9.5 km",
        elevation:"626 m",
        level: 'medium',
        showMore:false,
        description:"Try this loop trail near Tegher, Kotayk. Generally considered a moderately challenging route, it takes an average of 3 h 57 min to complete. This trail is great for hiking, and it's unlikely you'll encounter many other people while exploring. You'll need to leave pups at home — dogs aren't allowed on this trail."   
    },

    {
        id:2,
        image:'https://www.alltrails.com/api/alltrails/v2/trails/10304086/photos/0?size=larger_wide&key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i',
        title: "Lake Parz, GLake Gosh",
        length:"17.2 km",
        elevation:"910 m",
        level: 'hard',
        showMore:false,
        description:"Enjoy this out-and-back trail near Teghut, Tavush. Generally considered a moderately challenging route, it takes an average of 6 h 13 min to complete. This is a popular trail for birding, hiking, and walking, but you can still enjoy some solitude during quieter times of day. The best times to visit this trail are April through October."
    },

    {
        id:3,
        image:'https://www.alltrails.com/api/alltrails/v2/trails/10902156/photos/0?size=larger_wide&key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i',
        title: "Hagartsin Monastary Trail",
        length:"12.1 km",
        elevation:"745 m",
        level: 'medium',
        showMore:false,
        description:"Explore this point-to-point trail near Dilijan, Tavush. Generally considered a moderately challenging route, it takes an average of 4 h 55 min to complete. This is a popular trail for backpacking, camping, and hiking, but you can still enjoy some solitude during quieter times of day. The best times to visit this trail are May through November."
    },

    {
        id:4,
        image:'https://www.alltrails.com/api/alltrails/v2/trails/10304072/photos/0?size=larger_wide&key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i',
        title: "The Pagan Temple of Garni",
        length:"13.0 km",
        elevation:"763 m",
        level: 'medium',
        showMore:false,
        description:"Try this loop trail near Garni, Kotayk. Generally considered a moderately challenging route, it takes an average of 4 h 59 min to complete. This is a popular trail for hiking and walking, but you can still enjoy some solitude during quieter times of day. You'll need to leave pups at home — dogs aren't allowed on this trail."
    },
    {
        id:5,
        image:'https://www.alltrails.com/api/alltrails/v2/trails/10304076/photos/0?size=larger_wide&key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i',
        title: "Odzun, Horomayr",
        length:"8.9 km",
        elevation:"452 m",
        level: 'medium',
        showMore:false,
        description:" Try this point-to-point trail near Odzun, Lori. Generally considered a moderately challenging route, it takes an average of 3 h 36 min to complete. This is a popular trail for birding, hiking, and walking, but you can still enjoy some solitude during quieter times of day."
    },
    {
        id:6,
        image:'https://www.alltrails.com/api/alltrails/v2/trails/10305665/photos/0?size=larger_wide&key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i',
        title: "Stone Lake",
        length:"15.4 km",
        elevation:"1,410 m",
        level: 'hard',
        showMore: false,
        description:"Explore this out-and-back trail near Tegher, Kotayk. Generally considered a challenging route, it takes an average of 7 h 39 min to complete. This is a popular trail for birding, hiking, and walking, but you can still enjoy some solitude during quieter times of day."
    },

    {
        id:7,
        image:'https://www.alltrails.com/api/alltrails/v2/trails/10304069/photos/0?size=larger_wide&key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i',
        title: "Mount Ara",
        length:"10.3 km",
        elevation:"948 m",
        level: 'medium',
        showMore:'false',
        description:" Explore this loop trail near Ashtarak, Aragatsotn. Generally considered a challenging route, it takes an average of 5 h 8 min to complete. This is a popular trail for hiking, but you can still enjoy some solitude during quieter times of day. You'll need to leave pups at home — dogs aren't allowed on this trail."
    },
    {
        id:8,
        image:'https://www.alltrails.com/api/alltrails/v2/trails/10305823/photos/0?size=larger_wide&key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i',
        title: "Gutanasar",
        length:"5.1 km",
        elevation:"464 m",
        level: 'easy',
        showMore:false,
        description:"Discover this out-and-back trail near Tsakhkadzor, Kotayk. Generally considered a moderately challenging route, it takes an average of 2 h 19 min to complete. This is a very popular area for skiing, so you'll likely encounter other people while exploring."
    },
    {
        id:9,
        image:'https://www.alltrails.com/api/alltrails/v2/trails/11120162/photos/0?size=larger_wide&key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i',
        title: "Jurkhtak Monastery loop",
        length:"3.5 km",
        elevation:"198 m",
        level: 'easy',
        showMore:false,
        description:"Head out on this loop trail near Dilijan, Tavush. Generally considered an easy route, it takes an average of 1 h 19 min to complete. This is a very popular area for hiking, so you'll likely encounter other people while exploring."
    }


]